import * as React from "react";
import PageHeader from "../layout/PageHeader";

interface UnauthorizedViewProps {
    login: (userName: string, password: string) => void;
}

const UnauthorizedView: React.FunctionComponent<UnauthorizedViewProps> = props => {
    
   
    return null;
};

export default UnauthorizedView;
